// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bg_aFjHg {
  background-color: var(--_00000033-shadow);
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
}
.tagsContent_PwOvv {
  height: 100%;
  width: 100%;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 999;
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
}

.newTagContainer_xm1hT {
  width: 100%;
  max-width: 600px;
  box-sizing: border-box;
  border-radius: 10px;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  -ms-border-radius: 10px;
  -o-border-radius: 10px;
  background-color: var(--white-color);
  overflow: hidden;
  position: fixed;
  top: 50%;
  left: 50%;
  z-index: 999;
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  .newTagHeader_eXh6I {
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    border-bottom: 1px solid var(--e3-border);
    padding: 15px;
  }
  img {
    width: 15;
  }

  .newTagBody_DrZUA {
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid var(--e3-border);
    padding: 15px;
    gap: 20px;
    .circleContainer__4VLh {
      display: flex;
      justify-content: center;
      gap: 5px;
      padding-bottom: 25px;
      padding-top: 10px;
      flex-wrap: wrap;
    }
    .button__l8rq {
      cursor: pointer;
    }
    input {
      background-color: var(--f5-background);
      border: none;
      outline: none;
      padding: 10px;
      border-radius: 7px;
      -webkit-border-radius: 7px;
      -moz-border-radius: 7px;
      -ms-border-radius: 7px;
      -o-border-radius: 7px;
      box-sizing: border-box;
    }
    .circle_z2dtT {
      height: 25px;
      min-width: 25px;
      border-radius: 50%;
      -webkit-border-radius: 50%;
      -moz-border-radius: 50%;
      -ms-border-radius: 50%;
      -o-border-radius: 50%;
      border: 4px solid var(--white-color);
    }
    .selected_VMVbM {
      border: 4px solid #c3c3c3;
    }
  }
}
.tagsContainer_s_iod {
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-height: 235px;
  overflow-y: auto;
}
.tagWrapper_TWtAv {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  accent-color: var(--_10a37f-background);
  align-items: center;
}
.tag_E2ZFV {
  border-radius: 6px;
  width: 100%;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  -ms-border-radius: 6px;
  -o-border-radius: 6px;
  padding: 2px 6px;
  box-sizing: border-box;
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/NewTag/NewTag.module.css"],"names":[],"mappings":"AAAA;EACE,yCAAyC;EACzC,YAAY;EACZ,WAAW;EACX,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;AACd;AACA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,YAAY;EACZ,wCAAwC;EACxC,qCAAqC;EACrC,oCAAoC;EACpC,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,wBAAwB;EACxB,uBAAuB;EACvB,sBAAsB;EACtB,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;EACf,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,gCAAgC;EAChC,wCAAwC;EACxC,qCAAqC;EACrC,oCAAoC;EACpC,mCAAmC;EACnC;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,yCAAyC;IACzC,aAAa;EACf;EACA;IACE,SAAS;EACX;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,yCAAyC;IACzC,aAAa;IACb,SAAS;IACT;MACE,aAAa;MACb,uBAAuB;MACvB,QAAQ;MACR,oBAAoB;MACpB,iBAAiB;MACjB,eAAe;IACjB;IACA;MACE,eAAe;IACjB;IACA;MACE,sCAAsC;MACtC,YAAY;MACZ,aAAa;MACb,aAAa;MACb,kBAAkB;MAClB,0BAA0B;MAC1B,uBAAuB;MACvB,sBAAsB;MACtB,qBAAqB;MACrB,sBAAsB;IACxB;IACA;MACE,YAAY;MACZ,eAAe;MACf,kBAAkB;MAClB,0BAA0B;MAC1B,uBAAuB;MACvB,sBAAsB;MACtB,qBAAqB;MACrB,oCAAoC;IACtC;IACA;MACE,yBAAyB;IAC3B;EACF;AACF;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,uCAAuC;EACvC,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;EAChB,sBAAsB;AACxB","sourcesContent":[".bg {\n  background-color: var(--_00000033-shadow);\n  height: 100%;\n  width: 100%;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 999;\n}\n.tagsContent {\n  height: 100%;\n  width: 100%;\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 999;\n  -webkit-transform: translate(-50%, -50%);\n  -moz-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  -o-transform: translate(-50%, -50%);\n}\n\n.newTagContainer {\n  width: 100%;\n  max-width: 600px;\n  box-sizing: border-box;\n  border-radius: 10px;\n  -webkit-border-radius: 10px;\n  -moz-border-radius: 10px;\n  -ms-border-radius: 10px;\n  -o-border-radius: 10px;\n  background-color: var(--white-color);\n  overflow: hidden;\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  z-index: 999;\n  transform: translate(-50%, -50%);\n  -webkit-transform: translate(-50%, -50%);\n  -moz-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  -o-transform: translate(-50%, -50%);\n  .newTagHeader {\n    display: flex;\n    justify-content: space-between;\n    flex-direction: row;\n    border-bottom: 1px solid var(--e3-border);\n    padding: 15px;\n  }\n  img {\n    width: 15;\n  }\n\n  .newTagBody {\n    display: flex;\n    flex-direction: column;\n    border-bottom: 1px solid var(--e3-border);\n    padding: 15px;\n    gap: 20px;\n    .circleContainer {\n      display: flex;\n      justify-content: center;\n      gap: 5px;\n      padding-bottom: 25px;\n      padding-top: 10px;\n      flex-wrap: wrap;\n    }\n    .button {\n      cursor: pointer;\n    }\n    input {\n      background-color: var(--f5-background);\n      border: none;\n      outline: none;\n      padding: 10px;\n      border-radius: 7px;\n      -webkit-border-radius: 7px;\n      -moz-border-radius: 7px;\n      -ms-border-radius: 7px;\n      -o-border-radius: 7px;\n      box-sizing: border-box;\n    }\n    .circle {\n      height: 25px;\n      min-width: 25px;\n      border-radius: 50%;\n      -webkit-border-radius: 50%;\n      -moz-border-radius: 50%;\n      -ms-border-radius: 50%;\n      -o-border-radius: 50%;\n      border: 4px solid var(--white-color);\n    }\n    .selected {\n      border: 4px solid #c3c3c3;\n    }\n  }\n}\n.tagsContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  max-height: 235px;\n  overflow-y: auto;\n}\n.tagWrapper {\n  display: flex;\n  justify-content: space-between;\n  gap: 10px;\n  accent-color: var(--_10a37f-background);\n  align-items: center;\n}\n.tag {\n  border-radius: 6px;\n  width: 100%;\n  -webkit-border-radius: 6px;\n  -moz-border-radius: 6px;\n  -ms-border-radius: 6px;\n  -o-border-radius: 6px;\n  padding: 2px 6px;\n  box-sizing: border-box;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bg": `bg_aFjHg`,
	"tagsContent": `tagsContent_PwOvv`,
	"newTagContainer": `newTagContainer_xm1hT`,
	"newTagHeader": `newTagHeader_eXh6I`,
	"newTagBody": `newTagBody_DrZUA`,
	"circleContainer": `circleContainer__4VLh`,
	"button": `button__l8rq`,
	"circle": `circle_z2dtT`,
	"selected": `selected_VMVbM`,
	"tagsContainer": `tagsContainer_s_iod`,
	"tagWrapper": `tagWrapper_TWtAv`,
	"tag": `tag_E2ZFV`
};
export default ___CSS_LOADER_EXPORT___;
